export default `:host {
  display: block;
  height: 100%;
}

.picklist {
  display: flex;
  height: 100%;
  position: relative;
}

:not(.is-expanded) .picklist-section::before {
  background-color: var(--ids-color-transparent);
}

.picklist-section {
  height: 100%;
  width: 50%;
  flex: 0 0 50%;
}
.picklist-section:only-child {
  width: 100%;
  flex: 0 0 100%;
}
.picklist-section + .picklist-section::before {
  background-color: var(--ids-color-neutral-30);
  position: absolute;
  content: " ";
  width: 1px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: calc(75% + 14px);
  top: calc(12.5% - 4px);
}

.picklist-list {
  display: flex;
  list-style: none;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 100%;
}

.picklist-item {
  display: flex;
  cursor: pointer;
  border: 1px solid transparent;
  color: var(--ids-date-picker-picklist-item-color-text-default);
  padding-block: 1px;
  box-sizing: border-box;
  user-select: none;
  height: 12.5%;
  align-items: center;
  justify-content: center;
  contain: content;
  width: 100%;
}
.picklist-item ids-text {
  line-height: 0;
}
.picklist-item.is-selected {
  color: var(--ids-date-picker-picklist-item-color-text-selected);
  background-color: var(--ids-date-picker-picklist-item-color-background-selected);
}
.picklist-item.is-selected ids-text::part(text) {
  font-weight: 600;
}
.picklist-item:not(.is-year-nav):not(.is-month-nav):focus {
  border-color: var(--ids-date-picker-item-color-border-focus);
  box-shadow: var(--ids-date-picker-item-shadow-focus);
  outline: none;
}
.picklist-item.is-year-nav, .picklist-item.is-month-nav {
  z-index: 1;
}
.picklist-item.is-month-nav {
  width: calc(100% + 1px);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
